import { Modulo } from '../type';
import { buildEntidadeSegment, extractEntidadeFromPath } from './BaseHref';

export const getUrl = (
  modulo: Exclude<Modulo, 'compras-proposta'>,
  path: string
) => {
  if (!modulo || !path) {
    throw new Error('Módulo e path são obrigatórios.');
  }

  const { hostname, origin } = window.location;
  const isLocalhost =
    hostname.includes('local') || hostname.includes('cloudnet');
  const entidade = extractEntidadeFromPath();
  const segmento = entidade ? `/${buildEntidadeSegment(entidade)}` : '';

  return `${origin}${isLocalhost ? '' : `/${modulo}`}${segmento}${path}`;
};

// compras-proposta é público e tem rotas fixas ('/', '/cotacao'), sem segmento de entidade
export const getUrlPropostaExterna = (path: string): string => {
  if (!path) {
    throw new Error('Path é obrigatório.');
  }

  const { hostname, origin } = window.location;
  const isLocalhost = hostname.includes('local');

  return `${origin}${isLocalhost ? '' : '/compras-proposta'}${path}`;
};

export const isValidHttpUrl = (url: string) => {
  if (
    !url.toLocaleLowerCase().startsWith('http://') &&
    !url.toLocaleLowerCase().startsWith('https://')
  ) {
    return false;
  }

  try {
    const newUrl = new URL(url);
    return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
  } catch (e) {
    return false;
  }
};
